export enum Modules {
  Food = 'food',
  Sport = 'sport',
  Transport = 'transport',
  Health = 'health',
  Dormitory = 'dormitory',
}

export const modules = Object.values(Modules);
